import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';
import './QuestionsAndAnswers.css';

const QuestionsAndAnswers = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    const accordionData = [
        { 
            question: 'Что такое хакатон?', 
            answer: 'Хакатон - это командное соревнование, где программисты, дизайнеры и другие участники работают вместе, чтобы разработать прототип продукта, который решает определенную задачу.' 
        },
        { 
            question: 'Могут ли участники без опыта принять участие?', 
            answer: 'Конечно! Задачей нашего хакатона является повышение цифровой грамотности участников!' 
        },
        { 
            question: 'Что делать если нет команды?', 
            answer: 'Ничего страшного, если у вас нет команды, мы поможем вам её найти!' 
        },
        { 
            question: 'Мероприятие платное? Требуются ли орг. взносы?', 
            answer: 'Мероприятие абсолютно бесплатное для участия! Вам не нужно беспокоиться о каких-либо организационных взносах. Приходите и наслаждайтесь!' 
        },
    ];

    return (
        <div className="qna-container">
            <div className="qna-header">
                <HelpCircle className="header-icon" size={32} />
                <h1>Частые вопросы</h1>
            </div>
            
            <div className="qna-accordion">
                {accordionData.map((item, index) => (
                    <div 
                        className={`qna-item ${activeIndex === index ? 'active' : ''}`}
                        key={index}
                        onClick={() => toggleAccordion(index)}
                    >
                        <div className="qna-question">
                            <h3>{item.question}</h3>
                            {activeIndex === index ? 
                                <ChevronUp className="arrow-icon" /> : 
                                <ChevronDown className="arrow-icon" />
                            }
                        </div>
                        
                        <div className={`qna-answer ${activeIndex === index ? 'show' : ''}`}>
                            <p>{item.answer}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default QuestionsAndAnswers;